import { render, staticRenderFns } from "./CmgRecentsAndFavoritesPage.vue?vue&type=template&id=3b433816&scoped=true&lang=pug"
import script from "./cmg-recents-and-favorites-page.ts?vue&type=script&lang=ts&external"
export * from "./cmg-recents-and-favorites-page.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRecentsAndFavoritesPage.vue?vue&type=style&index=0&id=3b433816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b433816",
  null
  
)

export default component.exports